import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LabDipRequestDetailsComponent } from './components/lab-dips/lab-dip-request-details/lab-dip-request-details.component';
import { LabDipRequestsComponent } from './components/lab-dips/lab-dip-requests/lab-dip-requests.component';
import { ProcessesComponent } from './components/processes/processes/processes.component';
import { ProcessDetailsComponent } from './components/processes/process-details/process-details.component';
import { StepsComponent } from './components/processes/steps/steps.component';
import { StepDetailsComponent } from './components/processes/step-details/step-details.component';
import { LabDipsComponent } from './components/lab-dips/lab-dips/lab-dips.component';
import { ParametersComponent } from './components/processes/parameters/parameters.component';
import { GreigesComponent } from './components/greige/greiges/greiges.component';
import { GreigeDetailsComponent } from './components/greige/greige-details/greige-details.component';
import { FabricComponent } from './components/fabric/fabric/fabric.component';
import { AuthenticationGuard } from './guards/authentication.guard';
import { LoginComponent } from '@card-software/library';
import { FabricDetailsComponent } from './components/fabric/fabric-details/fabric-details.component';
import { LabDipDetailsComponent } from './components/lab-dips/lab-dip-details/lab-dip-details.component';
import { YarnComponent } from './components/yarn/yarn.component';
import { FabricCategoriesComponent } from './components/fabric/fabric-categories/fabric-categories.component';
import { FiberCategoriesComponent } from './components/fiber/fiber-categories/fiber-categories.component';
import { ItemCategoriesComponent } from './components/item/item-categories/item-categories.component';
import { ItemMasterComponent } from './components/item/item-master/item-master.component';
import { RoleGuard } from './guards/role.guard';
import {
  DataMasterAdminGroup,
  DataMasterViewerGroup,
  LapDipRequestRoles,
  LapDipRoles,
  ProductDevelopmentAdminGroup,
  ProductDevelopmentEditorGroup,
  ProductDevelopmentViewerGroup,
  TestLabDipAdminGroup,
} from './models/authorization/enum/user-group.enum';
import { UnauthorizedComponent } from './components/unauthorized/unauthorized.component';
import { defaultRouteGuard } from '@card-software/library';
import { MENU_ITEMS } from './app-menu';
import { CodesCreationsComponent } from './components/code-creation-request/codes-creations/codes-creations.component';
import { CodeCreationDetailComponent } from './components/code-creation-request/code-creation-detail/code-creation-detail.component';
import { RecipeDetailsComponent } from './components/dyeing/recipe-details/recipe-details.component';
import { RecipeContainerComponent } from './components/dyeing/recipe-container/recipe-container.component';
import { ProductRecipesComponent } from './components/product-recipe/product-recipes/product-recipes.component';
import { ProductRecipeDetailsComponent } from './components/product-recipe/product-recipe-details/product-recipe-details.component';
const routes: Routes = [
  {
    path: 'lab-dip-requests',
    component: LabDipRequestsComponent,
    canActivate: [AuthenticationGuard, RoleGuard],
    data: {
      breadcrumb: [{ label: 'LabDipRequests_Title' }],
      roles: [LapDipRequestRoles.LabDipRequestViewer, LapDipRequestRoles.LabDipRequestEditor, LapDipRequestRoles.LabDipRequestAdmin],
    },
  },
  {
    path: 'lab-dip-request-details',
    component: LabDipRequestDetailsComponent,
    canActivate: [AuthenticationGuard, RoleGuard],
    data: {
      breadcrumb: [
        { label: 'LabDipRequests_Title', route: '/lab-dip-requests' },
        { label: 'Common_Detail', awaitCurrent: true },
      ],
      roles: [LapDipRequestRoles.LabDipRequestViewer, LapDipRequestRoles.LabDipRequestEditor, LapDipRequestRoles.LabDipRequestAdmin],
    },
  },
  {
    path: 'lab-dip-details',
    component: LabDipDetailsComponent,
    canActivate: [AuthenticationGuard, RoleGuard],
    data: {
      breadcrumb: [
        { label: 'LabDips_Title', route: '/lab-dips' },
        { label: 'Common_Detail', awaitCurrent: true },
      ],
      roles: [LapDipRoles.LabDipViewer, LapDipRoles.LabDipEditor, LapDipRoles.LabDipAdmin],
    },
  },
  {
    path: 'lab-dips',
    component: LabDipsComponent,
    canActivate: [AuthenticationGuard, RoleGuard],
    data: {
      breadcrumb: [{ label: 'LabDips_Title' }],
      roles: [LapDipRoles.LabDipViewer, LapDipRoles.LabDipEditor, LapDipRoles.LabDipAdmin],
    },
  },
  {
    path: 'parameters',
    component: ParametersComponent,
    canActivate: [AuthenticationGuard, RoleGuard],
    data: {
      breadcrumb: [{ label: 'Parameter_Title' }],
      roles: [
        TestLabDipAdminGroup.TestLabDipAdmin,
        ProductDevelopmentAdminGroup.EngineeringAdmin,
        ProductDevelopmentEditorGroup.EngineeringEditor,
        ProductDevelopmentViewerGroup.EngineeringViewer,
      ],
    },
  },
  {
    path: 'processes',
    component: ProcessesComponent,
    canActivate: [AuthenticationGuard, RoleGuard],
    data: {
      breadcrumb: [{ label: 'Process_Title' }],
      roles: [
        TestLabDipAdminGroup.TestLabDipAdmin,
        ProductDevelopmentAdminGroup.EngineeringAdmin,
        ProductDevelopmentEditorGroup.EngineeringEditor,
        ProductDevelopmentViewerGroup.EngineeringViewer,
      ],
    },
  },
  {
    path: 'process-details',
    component: ProcessDetailsComponent,
    canActivate: [AuthenticationGuard, RoleGuard],
    data: {
      breadcrumb: [
        { label: 'Process_Title', route: '/processes' },
        { label: 'Common_Detail', awaitCurrent: true },
      ],
      roles: [
        TestLabDipAdminGroup.TestLabDipAdmin,
        ProductDevelopmentAdminGroup.EngineeringAdmin,
        ProductDevelopmentEditorGroup.EngineeringEditor,
        ProductDevelopmentViewerGroup.EngineeringViewer,
      ],
    },
  },
  {
    path: 'steps',
    component: StepsComponent,
    canActivate: [AuthenticationGuard, RoleGuard],
    data: {
      breadcrumb: [{ label: 'Step_Title' }],
      roles: [
        TestLabDipAdminGroup.TestLabDipAdmin,
        ProductDevelopmentAdminGroup.EngineeringAdmin,
        ProductDevelopmentEditorGroup.EngineeringEditor,
        ProductDevelopmentViewerGroup.EngineeringViewer,
      ],
    },
  },
  {
    path: 'step-details',
    component: StepDetailsComponent,
    canActivate: [AuthenticationGuard, RoleGuard],
    data: {
      breadcrumb: [
        { label: 'Step_Title', route: '/steps' },
        { label: 'Common_Detail', awaitCurrent: true },
      ],
      roles: [
        TestLabDipAdminGroup.TestLabDipAdmin,
        ProductDevelopmentAdminGroup.EngineeringAdmin,
        ProductDevelopmentEditorGroup.EngineeringEditor,
        ProductDevelopmentViewerGroup.EngineeringViewer,
      ],
    },
  },
  {
    path: 'greiges',
    component: GreigesComponent,
    canActivate: [AuthenticationGuard, RoleGuard],
    data: {
      breadcrumb: [{ label: 'Greige_Title' }],
      roles: [
        ProductDevelopmentViewerGroup.GreigeViewer,
        ProductDevelopmentEditorGroup.GreigeEditor,
        ProductDevelopmentAdminGroup.GreigeAdmin,
      ],
    },
  },
  {
    path: 'greige-details',
    component: GreigeDetailsComponent,
    canActivate: [AuthenticationGuard, RoleGuard],
    data: {
      breadcrumb: [
        { label: 'Greige_Title', route: '/greiges' },
        { label: 'Common_Detail', awaitCurrent: true },
      ],
      roles: [
        ProductDevelopmentViewerGroup.GreigeViewer,
        ProductDevelopmentEditorGroup.GreigeEditor,
        ProductDevelopmentAdminGroup.GreigeAdmin,
      ],
    },
  },
  {
    path: 'fabric',
    component: FabricComponent,
    canActivate: [AuthenticationGuard, RoleGuard],
    data: {
      breadcrumb: [{ label: 'Fabric_Title' }],
      roles: [
        ProductDevelopmentViewerGroup.FabricViewer,
        ProductDevelopmentEditorGroup.FabricEditor,
        ProductDevelopmentAdminGroup.FabricAdmin,
      ],
    },
  },
  {
    path: 'fabric-details',
    component: FabricDetailsComponent,
    canActivate: [AuthenticationGuard, RoleGuard],
    data: {
      breadcrumb: [
        { label: 'Fabric_Title', route: '/fabric' },
        { label: 'Common_Detail', awaitCurrent: true },
      ],
      roles: [
        ProductDevelopmentViewerGroup.FabricViewer,
        ProductDevelopmentEditorGroup.FabricEditor,
        ProductDevelopmentAdminGroup.FabricAdmin,
      ],
    },
  },
  {
    path: 'fabric-categories',
    component: FabricCategoriesComponent,
    canActivate: [AuthenticationGuard, RoleGuard],
    data: {
      breadcrumb: [{ label: 'Fabric_Categories_Title' }],
      roles: [ProductDevelopmentViewerGroup.FabricCategoriesViewer, ProductDevelopmentAdminGroup.FabricCategoriesAdmin],
    },
  },
  {
    path: 'fiber-categories',
    component: FiberCategoriesComponent,
    canActivate: [AuthenticationGuard, RoleGuard],
    data: {
      breadcrumb: [{ label: 'Fiber_Categories_Title' }],
      roles: [ProductDevelopmentViewerGroup.FiberCategoriesViewer, ProductDevelopmentAdminGroup.FiberCategoriesAdmin],
    },
  },
  {
    path: 'item-master',
    component: ItemMasterComponent,
    canActivate: [AuthenticationGuard, RoleGuard],
    data: {
      breadcrumb: [{ label: 'Item_Master_Title' }],
      roles: [DataMasterViewerGroup.ItemMasterViewer, DataMasterAdminGroup.ItemMasterAdmin],
    },
  },
  {
    path: 'item-categories',
    component: ItemCategoriesComponent,
    canActivate: [AuthenticationGuard, RoleGuard],
    data: {
      breadcrumb: [{ label: 'Item_Categories_Title' }],
      roles: [DataMasterViewerGroup.ItemCategoriesViewer, DataMasterAdminGroup.ItemCategoriesAdmin],
    },
  },
  {
    path: 'code-creation-requests',
    component: CodesCreationsComponent,
    canActivate: [AuthenticationGuard, RoleGuard],
    data: {
      breadcrumb: [{ label: 'Code_Creation_Requests_Title' }],
      roles: [DataMasterViewerGroup.ItemCodeRequestViewer, DataMasterAdminGroup.ItemMasterAdmin],
    },
  },
  {
    path: 'code-creation-detail',
    component: CodeCreationDetailComponent,
    canActivate: [AuthenticationGuard, RoleGuard],
    data: {
      breadcrumb: [{ label: 'Code_Creation_Requests_Title', route: '/code-creation-requests' }, { label: 'CodeCreationDetail.Title' }],
      roles: [DataMasterViewerGroup.ItemCodeRequestViewer, DataMasterAdminGroup.ItemMasterAdmin],
    },
  },
  {
    path: 'yarns',
    component: YarnComponent,
    canActivate: [AuthenticationGuard, RoleGuard],
    data: {
      breadcrumb: [{ label: 'Yarn_Title' }],
      roles: [ProductDevelopmentViewerGroup.YarnViewer, ProductDevelopmentAdminGroup.YarnAdmin],
    },
  },
  {
    path: 'recipe-details',
    component: RecipeDetailsComponent,
    canActivate: [AuthenticationGuard, RoleGuard],
    data: {
      breadcrumb: [
        { label: 'LabDips_Title', route: '/lab-dips' },
        { label: 'Common_Detail', awaitCurrent: true },
      ],
      roles: [TestLabDipAdminGroup.TestLabDipAdmin],
    },
  },
  {
    path: 'recipe-container',
    component: RecipeContainerComponent,
    canActivate: [AuthenticationGuard, RoleGuard],
    data: {
      breadcrumb: [
        { label: 'LabDips_Title', route: '/lab-dips' },
        { label: 'LabDips_Recipes_For', awaitCurrent: true },
      ],
      roles: [LapDipRoles.LabDipViewer, LapDipRoles.LabDipEditor, LapDipRoles.LabDipAdmin, TestLabDipAdminGroup.TestLabDipAdmin],
    },
  },
  {
    path: 'product-recipes',
    component: ProductRecipesComponent,
    canActivate: [AuthenticationGuard, RoleGuard],
    data: {
      breadcrumb: [{ label: 'ProductRecipe_Title' }],
      roles: [
        ProductDevelopmentViewerGroup.ProductRecipeViewer,
        ProductDevelopmentEditorGroup.ProductRecipeEditor,
        ProductDevelopmentAdminGroup.ProductRecipeAdmin,
      ],
    },
  },
  {
    path: 'product-recipe-details',
    component: ProductRecipeDetailsComponent,
    canActivate: [AuthenticationGuard, RoleGuard],
    data: {
      breadcrumb: [
        { label: 'ProductRecipe_Title', route: '/product-recipes' },
        { label: 'Common_Detail', awaitCurrent: true },
      ],
      roles: [
        ProductDevelopmentViewerGroup.ProductRecipeViewer,
        ProductDevelopmentEditorGroup.ProductRecipeEditor,
        ProductDevelopmentAdminGroup.ProductRecipeAdmin,
      ],
    },
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'unauthorized',
    component: UnauthorizedComponent,
  },
  {
    path: '',
    pathMatch: 'full',
    canActivate: [AuthenticationGuard, defaultRouteGuard(MENU_ITEMS, 'Item')],
    component: UnauthorizedComponent,
  },
  {
    path: '**',
    redirectTo: '',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
